export const PREVIEW_ZOOM_DIALOG_ID = 'print-order-preview-zoom';

/** Rendered PDF page width at 100% on a wide screen; zoom scales it. */
export const BASE_PAGE_WIDTH = 940;
/** Horizontal padding of the scroll area, see `styles.ts`. */
export const SCROLL_AREA_PADDING = 16;

export const MIN_ZOOM = 0.5;
export const MAX_ZOOM = 3;
export const ZOOM_STEP = 0.25;
